export default __webpack_public_path__ + "static/media/OMIWorkshop_2022_ElicitableRL.63a0f251.pdf";